import { type Common } from './common.js';
import {
  type Entity,
  type Result,
  type SearchMode,
  type SearchQueryParams,
} from './models/search.js';

export class API {
  common: Common;
  baseEndpoint: string;

  constructor(common: Common) {
    this.common = common;
    this.baseEndpoint = '/search';
  }

  async search(queryParams: SearchQueryParams): Promise<Result[]> {
    const url = this.common.constructPath(this.baseEndpoint, queryParams);
    return await this.common.getJSON(url);
  }

  async flowBuilderSearch(
    q: string,
    entityType: Entity,
    organizationId: string,
    searchMode?: SearchMode
  ): Promise<Result[]> {
    const url = this.common.constructPath(`${this.baseEndpoint}/flow`, {
      q,
      entityType,
      organizationId,
      searchMode,
    });
    return await this.common.getJSON(url);
  }
}
